import { useTranslation } from "@bounce/i18n"

import type { Interpolations } from "./useInterpolations"
import type StepCompact from "@/components/LuggageStorage/HowItWorks/HowItWorksCompact/types"

import markerImg from "@bounce/assets/big-icons/marker.png"
import starImg from "@bounce/assets/big-icons/star.png"
import headToStoreImg from "@bounce/assets/big-icons/walk.png"

type UseStepsCompactOptions = {
  interpolations: Interpolations
}

export const useStepsCompact = ({ interpolations }: UseStepsCompactOptions): StepCompact[] => {
  const { t } = useTranslation()

  return [
    {
      src: markerImg,
      title: t("screen.cityScreen.stepsCompact.stepOneTitleV2", "Book in a tap on the Bounce app"),
      description: t(
        "screen.cityScreen.stepsCompact.stepOneDescription",
        "Find a convenient luggage storage location to drop off your bags.",
      ),
    },
    {
      src: headToStoreImg,
      title: t("screen.cityScreen.stepsCompact.stepTwoTitle", "Go to the bag storage location"),
      description: t(
        "screen.cityScreen.stepsCompact.stepTwoDescription",
        "We partner with trusted local businesses with secure areas to store your stuff.",
      ),
    },
    {
      src: starImg,
      title: t(
        "screen.cityScreen.stepsCompact.stepThreeTitle",
        "Store your bags and enjoy {{CITY_NAME}}",
        interpolations,
      ),
      description: t(
        "screen.cityScreen.stepsCompact.stepThreeDescription",
        "Show your confirmation to the Bounce Partner to drop off your stuff, then you’re free to explore {{CITY_NAME}}!",
        interpolations,
      ),
    },
  ]
}
